import React, { useState, useEffect } from "react"
import Moment from 'react-moment'
import ModalDialog from 'components/ModalDialog'

import {
    DeleteForeverTwoTone
} from '@material-ui/icons'
import ErrorLine from 'components/ErrorLine'
import { canDeletePost } from 'util/transactionUtils'
import { useHistory } from 'react-router-dom'
import 'react-h5-audio-player/lib/styles.css'
import { addComment, deleteComment } from 'util/socialServiceUtils'
import { useDispatch, useSelector } from 'react-redux'
import { canComment } from 'util/transactionUtils'
import { getAccountId } from 'redux/actions/accountActions'
import { getStorageAccount } from 'redux/actions/accountActions'
import { displayError } from 'util/screenUtils'
import SmallProfileImage from 'components/auction/SmallProfileImage'
import { getRoomById } from 'controllers/VortexController'
import { setAllowSwipe } from 'redux/actions/displayActions'

export default function CommentArea({ messageSocket }) {

    const { playListIndex } = useSelector(state => state.harmonize)
    const { playList } = useSelector(state => state.messages)
    const { accessType, userId: songUserId, _id: messageId, comments, roomId } = playList[playListIndex]
    const { currentRoom } = useSelector(state => state.messages)
    const [confirmDeleteComment, setConfirmDeleteComment] = useState(false)
    const [comment, setComment] = useState()
    const [commentId, setCommentId] = useState()
    const [commentRoom, setCommentRoom] = useState()
    const [error, setError] = useState()
    const userId = getAccountId()
    const { handle } = getStorageAccount()
    const dispatch = useDispatch()
    const history = useHistory()

    const deleteThisComment = () => {
        try {
            deleteComment(commentId, userId, messageSocket)
            setCommentId()
        } catch (error) {
            const message = `error deleting comment ${commentId}`
            console.error(message, error)
            displayError({ message }, setError)
        }
    }
    const postComment = () => {
        try {
            addComment(messageId, comment, userId, handle, messageSocket)
            setComment("")
        } catch (error) {
            const message = `error adding comment`
            console.error(message, error)
            displayError({ message }, setError)
        }
    }
    const displayCommentInputArea = () => {
        if (canComment(accessType, songUserId)) {
            if (currentRoom) {
                return (
                    <div style={{ display: 'flex', width: '100%' }}>

                        <textarea
                            style={{ width: '100%', overflowWrap: 'break-word' }}
                            type="text"
                            maxLength={process.env.REACT_APP_MAX_HARMONIZE_MESSAGE_LENGTH}
                            placeholder="Add a comment..."
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />
                        <button
                            className="comment__button text__button"
                            disabled={!comment}
                            onClick={async () => postComment()}
                        >
                            Send
                        </button>


                    </div>)
            } else if (commentRoom) {
                const { name, user } = commentRoom
                const { handle } = user
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
                        onClick={() => {
                            dispatch(setAllowSwipe(true))
                            history.replace(`/@${handle}/${name}`)
                        }
                        }
                    >
                        <span style={{ color: 'purple' }}>Add a comment</span>
                    </div>
                )
            }
        }

    }
    const displayComment = (c) => {

        const { _id, handle, userId, comment, createdAt } = c
        return (
            <div key={createdAt}>
                {canDeletePost(songUserId) ? <DeleteForeverTwoTone
                    color='error'
                    fontSize='small'
                    style={{ cursor: 'pointer' }}
                    onClick={(evt) => {
                        evt.stopPropagation()
                        setCommentId(_id)
                        setConfirmDeleteComment(!confirmDeleteComment)
                    }}
                /> : null}
                <span style={{ fontSize: '0.75em', display: 'flex' }}> <SmallProfileImage
                    userId={userId}
                />{handle} (<Moment fromNow>{createdAt}</Moment>): {comment}</span>
            </div>
        )

    }
    const displayComments = () => {
        return (<div >
            {comments.map((comment) => (
                displayComment(comment)
            ))}
        </div>)

    }

    const displayMain = () => {
        return (
            <div>
                <ErrorLine error={error} />
                {displayComments()}
                {displayCommentInputArea()}
                <ModalDialog
                    title='Confirm Delete Comment'
                    message={`Are you sure you want to permanently delete this comment?`}
                    close={() => setConfirmDeleteComment(false)}
                    open={confirmDeleteComment}
                    noLabel='No'
                    no={() => setConfirmDeleteComment(false)}
                    yesLabel='Yes'
                    yes={async () => {
                        setConfirmDeleteComment(false)
                        deleteThisComment()
                    }}
                />
            </div>
        )
    }

    useEffect(() => {

        const getCommentRoom = async () => {
            try {
                const room = await getRoomById(roomId)
                setCommentRoom(room)
            } catch (error) {
                displayError(error, setError)
            }
        }
        getCommentRoom()
    }, [])
    return displayMain()
}